import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Checkbox, Divider, Flex, HStack, Stack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';

import { AppDispatch } from '../../../store';
import { updateBetaTester } from '../../../store/actions';

export const GeneralView = () => {

    const [isUpdatingBetaTester, setUpdatingBetaTester] = useState<boolean>(false);
    const [isBetaTester, setBetaTester] = useState<boolean>(false);
    const { company } = useAppSelector(state => state.companyReducer);
    const { company_id, is_beta_tester } = company;

    const dispatch: AppDispatch = useAppDispatch();

    const handleUpdateBetaTester = () => {
        setUpdatingBetaTester(true);
        dispatch(updateBetaTester({
            company_id,
            is_beta_tester: isBetaTester
        }))
            .finally(() => setUpdatingBetaTester(false));
    };

    const setKeyValues = () => {
        setBetaTester(is_beta_tester);
    };

    useEffect(() => {
        setKeyValues();
    }, []);

    return (
        <>
            <Flex>
                <Stack bg={'#FFFFFF'} p={4} borderRadius={6} w={'full'}>
                    <Text fontSize={'xl'} fontWeight={'medium'}>General.</Text>

                    <Divider />

                    <Accordion defaultIndex={[0, 1, 2]} allowMultiple allowToggle={false}>

                        <AccordionItem boxShadow={'md'} borderRadius={4} border={'none'} mt={6}>
                            <h2>
                                <AccordionButton bg={'gray.50'} minH={'50px'} disabled>
                                    <Box as='span' flex='1' textAlign='left' fontWeight={'medium'}>
                                        Beta Feature Testing
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text fontSize={'sm'} color={'gray.900'} mt={0} fontWeight={'medium'}>Beta Tester?</Text>
                                        <Checkbox colorScheme={'yellow'} mt={'2px !important'} isChecked={isBetaTester} onChange={() => setBetaTester(!isBetaTester)}>Yes</Checkbox>
                                        <Text fontSize={'xs'} color={'gray.500'} mt={'0px !important'}>Test features that are being tested for new releases and give feedback.</Text>
                                    </Stack>
                                    <Button
                                        size={'sm'}
                                        isLoading={isUpdatingBetaTester}
                                        isDisabled={isUpdatingBetaTester}
                                        colorScheme={'yellow'}
                                        onClick={handleUpdateBetaTester}
                                    >Update</Button>
                                </HStack>
                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>
                </Stack>
            </Flex>
        </>
    );
};